import styled from '@emotion/styled'
import { HeaderContainer, HeaderNav, HeaderWrapper } from 'components/header/Header'
import { BREAKPOINTS } from 'utils/styled'

export const SHeaderWrapper = styled(HeaderWrapper)`
  --width: var(--digital-legacy-width);
`

export const SHeaderContainer = styled(HeaderContainer)`
  @media ${BREAKPOINTS.LG.min} {
    grid-column-start: unset;
    grid-column-end: unset;
    padding: 0;
  }
`

export const SHeaderNav = styled(HeaderNav)`
  &::-webkit-scrollbar {
    display: none;
  }

  a {
    color: var(--c-gray100);
    cursor: pointer;
  }
`
